<div class="choosegroup dropdown dropclick">
  <input type="text" readonly="readonly" placeholder="{{'Choose group'|translate}}"
         (input)="onTermChange($event)"
         [(ngModel)]="selectedGroup.Name"/>
  <div class="dropcontent dontclose">
    <div class="dropcontentinset">
      <button class="btnaddgroup" (click)="addGroup()" *ngIf="isEditable">{{'Add group'|translate }}</button>
      <input type="text" class="searchinput" placeholder="{{'Find group'|translate}}" [(ngModel)]="groupNameFilter"/>
      <ul>
        <li class="spanitem" [class.activegroup]="selectedGroup == allGroupsItem"
            (click)="selectGroup(allGroupsItem)">
          <span>{{allGroupsItem.Name}}</span>
          <span></span>
        </li>
        <li [class.activegroup]="selectedGroup == group" class="spanitem" *ngFor="let group of groups | filterByName : groupNameFilter">
          <span (click)="selectGroup(group)">{{group.Name}}</span>
          <span>{{group.Count}}</span>
          <div class="dropdown" *ngIf="isEditable">
            <button class="btn_moregray" (click)="openMgmtDropdown(group,$event)"></button>
            <ul *ngIf="group.isMgmtOpen" [style.display]="group.isMgmtOpen ? 'block':'none'" [style.left.px]="group.mgmtxPos" [style.top.px]="group.mgmtyPos">
              <li [class.disabled]="!isEditAllowed(group)" (click)="isEditAllowed(group) && editGroup(group)">
                {{'Edit'|translate }}
              </li>
              <li class="separator"></li>
              <li [class.disabled]="!isDeleteAllowed(group)" (click)="isDeleteAllowed(group) && deleteGroup(group)" class="red">
                {{'Delete'|translate }}
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
